{
  "account-existed-dialog": {
    "buttons": {
      "cancel": "Zrušit",
      "login": "Přihlášení"
    },
    "text": {
      "title": "Účet s těmito e-maily již existuje: {{ email }} nebo telefonní číslo: {{ phoneNr }}",
      "title-email-exists": "Účet s těmito e-maily již existuje: {{ email }}",
      "title-phone-exists": "S tímto telefonním číslem již existuje účet: {{ phoneNr }}",
      "hint": "Můžete se přihlásit přímo pomocí tohoto e-mailu/telefonního čísla nebo k registraci použít jiný e-mail/telefonní číslo.",
      "hint-email-exists": "Můžete se přihlásit přímo pomocí tohoto e-mailu nebo k registraci použít jiný e-mail.",
      "hint-phone-exists": "Můžete se přihlásit přímo pomocí tohoto telefonního čísla nebo k registraci použít jiné telefonní číslo."
    }
  }
}
